module.exports = __webpack_public_path__ + "img/202505_06.95617dc1.jpg";